import { render, staticRenderFns } from "./policy-branch.vue?vue&type=template&id=9f0e20a0&scoped=true"
import script from "./policy-branch.js?vue&type=script&lang=js&external"
export * from "./policy-branch.js?vue&type=script&lang=js&external"
import style0 from "./policy-branch.vue?vue&type=style&index=0&id=9f0e20a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f0e20a0",
  null
  
)

export default component.exports